"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15068],{

/***/ 11913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_hexOpacity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84607);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 12px;\n      width: 12px;\n      font-size: 10px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      min-width: 38px;\n      height: 20px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  padding: 0;\n\n  height: 20px;\n  width: 20px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n\n  cursor: pointer;\n\n  color: ",
        ";\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 20px;\n\n  box-sizing: border-box;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-84f991d8-0"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].chardonnay */ .Z.chardonnay + (0,_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(10), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].yellowSea */ .Z.yellowSea, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].yellowSea */ .Z.yellowSea, function(param) {
    var isSmall = param.isSmall;
    return isSmall && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
}, function(param) {
    var isUma = param.isUma;
    return isUma && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
});
/* harmony default export */ __webpack_exports__["Z"] = (Tag);


/***/ }),

/***/ 92292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Notation_Content; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/Notation/styled.ts + 1 modules
var styled = __webpack_require__(69836);
;// CONCATENATED MODULE: ./src/global/Notation/NotationListItem.tsx



function NotationListItem(param) {
    var code = param.code, desc = param.desc, _isUma = param.isUma, isUma = _isUma === void 0 ? false : _isUma;
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        justify: "space-between",
        mb: "10px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "flex-end",
                width: "44px",
                mr: "12px",
                pb: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationTag */.GU, {
                    isUma: isUma,
                    children: code
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Description */.dk, {
                children: desc
            })
        ]
    }));
}
/* harmony default export */ var Notation_NotationListItem = (NotationListItem);

;// CONCATENATED MODULE: ./src/global/Notation/Content.tsx








function Content(_param) {
    var notation = _param.notation, symbol = _param.symbol, name = _param.name, notationTag = _param.notationTag, props = (0,_object_without_properties/* default */.Z)(_param, [
        "notation",
        "symbol",
        "name",
        "notationTag"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Container */.W2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "column",
        align: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        as: "h1",
                        size: "20px",
                        height: "24px",
                        align: "center",
                        family: "bold",
                        children: symbol
                    }),
                    notationTag
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "center",
                align: "center",
                py: "14px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "p",
                    align: "center",
                    children: "Perusahaan memiliki Notasi Khusus sebagai berikut:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationList */.HC, {
                direction: "column",
                align: "center",
                justify: "space-evenly",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: notation.map(function(param) {
                        var notation_code = param.notation_code, notation_desc = param.notation_desc, code = param.code, desc = param.desc;
                        return code && desc || notation_code && notation_desc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation_NotationListItem, {
                            code: notation_code || code,
                            desc: notation_desc || desc
                        }, "notation-".concat(code)) : null;
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ var Notation_Content = (Content);


/***/ }),

/***/ 15068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16368);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92292);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69836);






var INDICATOR_ICON_URL = "/icon/ic_indicator.svg";
var UMA_ICON_URL = "/icon/ic_uma.svg";
var X_ICON_URL = "/icon/ic_x.svg";
var NOTATION_TYPE = {
    INDICATOR: "indicator",
    UMA: "uma",
    X: "x"
};
var INDICATOR_ALT_TEXT = "indikator notasi khusus";
function Notation(param) {
    var symbol = param.symbol, notation = param.notation, uma = param.uma, isModal = param.isModal, name = param.name, _isPopover = param.isPopover, isPopover = _isPopover === void 0 ? true : _isPopover, _type = param.type, type = _type === void 0 ? NOTATION_TYPE.INDICATOR : _type, _isNotationBadges = param.isNotationBadges, isNotationBadges = _isNotationBadges === void 0 ? false : _isNotationBadges, _className = param.className, className = _className === void 0 ? "" : _className, _placement = param.placement, placement = _placement === void 0 ? "top" : _placement;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), visible = ref[0], setVisible = ref[1];
    var onCloseModal = function() {
        return setVisible(false);
    };
    var isUma = type === NOTATION_TYPE.UMA && !!uma;
    var isX = type === NOTATION_TYPE.X;
    var renderTag = function(param) {
        var _type = param.// eslint-disable-next-line @typescript-eslint/no-shadow
        type, type = _type === void 0 ? NOTATION_TYPE.INDICATOR : _type, _isNotationBadges = param.// eslint-disable-next-line @typescript-eslint/no-shadow
        isNotationBadges, isNotationBadges = _isNotationBadges === void 0 ? false : _isNotationBadges, _src = param.src, src = _src === void 0 ? INDICATOR_ICON_URL : _src, _alt = param.alt, alt = _alt === void 0 ? INDICATOR_ALT_TEXT : _alt;
        return(// @ts-expect-error
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotationTag */ .GU, {
            type: type,
            isSmall: true,
            isNotationBadges: isNotationBadges,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                alt: alt,
                src: src
            })
        }));
    };
    var renderNotation = function() {
        if (isUma) {
            return renderTag({
                type: NOTATION_TYPE.UMA,
                src: UMA_ICON_URL,
                alt: "".concat(INDICATOR_ALT_TEXT, " uma"),
                className: "",
                isNotationBadges: isNotationBadges
            });
        }
        if (isX) {
            return renderTag({
                type: NOTATION_TYPE.X,
                src: X_ICON_URL,
                alt: "".concat(INDICATOR_ALT_TEXT, " x"),
                className: "",
                isNotationBadges: isNotationBadges
            });
        }
        return renderTag({
            type: type,
            isNotationBadges: isNotationBadges
        });
    };
    var renderContent = function() {
        var isFullSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Content__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            symbol: symbol,
            uma: uma,
            notation: notation,
            name: name,
            notationTag: renderTag({
                type: NOTATION_TYPE.INDICATOR,
                isNotationBadges: true
            }),
            isFullSize: isFullSize
        });
    };
    if (isModal) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: function() {
                        return setVisible(true);
                    },
                    "aria-hidden": "true",
                    children: renderTag({
                        type: NOTATION_TYPE.INDICATOR,
                        isNotationBadges: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    visible: visible,
                    onCancel: onCloseModal,
                    title: null,
                    centered: true,
                    width: "500px",
                    children: renderContent(true)
                })
            ]
        });
    }
    if (!isPopover) {
        return renderNotation();
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PopoverIndicator */ .H9, {
        className: className,
        content: renderContent(),
        // @ts-expect-error
        placement: placement,
        children: renderNotation()
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Notation);


/***/ }),

/***/ 69836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lw": function() { return /* binding */ BadgeLabelWrapper; },
  "W2": function() { return /* binding */ Container; },
  "dk": function() { return /* binding */ Description; },
  "CC": function() { return /* binding */ IconArrow; },
  "Qu": function() { return /* binding */ ModalIndicatorBar; },
  "L$": function() { return /* binding */ MultiplierChip; },
  "cF": function() { return /* binding */ MultiplierContainer; },
  "Nj": function() { return /* binding */ NotationBadgeContainer; },
  "H_": function() { return /* binding */ NotationBar; },
  "HC": function() { return /* binding */ NotationList; },
  "MC": function() { return /* binding */ NotationPopoverContainer; },
  "GU": function() { return /* binding */ NotationTag; },
  "LA": function() { return /* binding */ PopoverBadgeContainer; },
  "H9": function() { return /* binding */ PopoverIndicator; },
  "o7": function() { return /* binding */ TradingLimitBadge; }
});

// UNUSED EXPORTS: BadgeLabelDayTrade

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/notation/Tag.js
var Tag = __webpack_require__(11913);
;// CONCATENATED MODULE: ./src/@deprecated-ui/notation/index.js
// eslint-disable-next-line import/prefer-default-export


// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Notation/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 36px;\n      width: 100%;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 2px;\n  margin: auto;\n  padding: 20px 28px;\n  width: 350px;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  font-size: 14px;\n  line-height: 15px;\n  padding-bottom: 10px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: scroll;\n  max-height: 300px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: rgba(235, 160, 49, 0.03);\n  cursor: pointer;\n  height: 38px;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    height: unset;\n    justify-content: center;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n    text-align: center;\n    width: unset;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 20px;\n    width: 20px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    height: 12px;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n    width: 22.8px;\n    cursor: unset;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    width: 12px;\n    height: 12px;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin-right: 0;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin-bottom: 2px;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: #fef4e8;\n  border: 1px solid #f5931b;\n  color: #f5931b;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  font-family: ProximaNovaBd;\n\n  ",
        "\n\n  ",
        "\n  > .notation-label__icon {\n    height: 12px;\n    width: 12px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #8277f8;\n  font-size: 12px;\n  font-weight: 700;\n  color: #8277f8;\n  background-color: #f5f0ff;\n  padding: 2px 4.5px 2px 2px;\n  height: 16px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n\n  &:before {\n    content: '\\e968';\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ], [
        "\n  color: ",
        ";\n  font-size: 12px;\n\n  &:before {\n    content: '\\\\e968';\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-close {\n    color: rgba(0, 0, 0, 0.43);\n\n    .ant-modal-close-x {\n      font-size: 14px;\n      height: 48px;\n      line-height: 48px;\n      width: 48px;\n\n      .ant-modal-close-icon {\n        color: rgba(0, 0, 0, 0.43);\n        height: 14px;\n        width: 14px;\n\n        > svg {\n          fill: inherit;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: unset !important;\n  min-width: 12px;\n  height: 12px;\n  gap: 2px;\n  border: 1px solid #f5931b;\n  border-radius: 2px;\n  background-color: #fef4e8;\n  padding: 0 2.5px;\n  color: #f5931b;\n  font-size: 9px;\n  line-height: normal;\n  font-family: var(--font-regular);\n  margin: 0;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-left: 8px;\n  position: relative;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid #8277f8;\n  border-radius: 2px;\n  height: 16px;\n  padding: 0 4.5px 0 2px;\n  color: #8277f8;\n  background-color: #f5f0ff;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #94b041;\n  font-family: var(--font-regular);\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.2px;\n  color: #94b041;\n  border-radius: 2px;\n  background: #f2f6e8;\n  text-align: center;\n  height: 16px;\n  display: inline-block;\n  position: relative;\n  padding: 0 2px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 375px;\n  border: 1px solid #dadada;\n  padding: 20px;\n  border-radius: 4px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}








var Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-61468579-0"
})(_templateObject1(), color/* default.light */.Z.light, // @ts-expect-error
function(param) {
    var isFullsize = param.isFullsize;
    return isFullsize && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-61468579-1"
})(_templateObject2(), color/* default.component */.Z.component);
var NotationList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-2"
})(_templateObject3());
var NotationBar = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-61468579-3"
})(_templateObject4());
var notationTagVariant = {
    indicator: (0,styled_components_browser_esm/* css */.iv)(_templateObject5()),
    notation: (0,styled_components_browser_esm/* css */.iv)(_templateObject6()),
    uma: (0,styled_components_browser_esm/* css */.iv)(_templateObject7()),
    x: (0,styled_components_browser_esm/* css */.iv)(_templateObject8())
};
var NotationTag = (0,styled_components_browser_esm/* default */.ZP)(Tag/* default */.Z).withConfig({
    componentId: "sc-61468579-4"
})(_templateObject11(), // @ts-expect-error
function(param) {
    var type = param.type;
    return notationTagVariant[type];
}, // @ts-expect-error
function(param) {
    var isNotationBadges = param.isNotationBadges;
    return isNotationBadges ? (0,styled_components_browser_esm/* css */.iv)(_templateObject9()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject10());
});
var BadgeLabelWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "center",
    px: "5px",
    py: "2px",
    ml: "5px"
}).withConfig({
    componentId: "sc-61468579-5"
})(_templateObject12(), color/* default.primary */.Z.primary);
var BadgeLabelDayTrade = (0,styled_components_browser_esm/* default */.ZP)(BadgeLabelWrapper).withConfig({
    componentId: "sc-61468579-6"
})(_templateObject13());
var IconArrow = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* default */.Z).withConfig({
    componentId: "sc-61468579-7"
})(_templateObject14(), color/* default.yellowSea */.Z.yellowSea, color/* default.yellowSea */.Z.yellowSea);
var ModalIndicatorBar = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).attrs({
    maskStyle: {
        backgroundColor: "rgba(0,0,0,0.8)"
    }
}).withConfig({
    componentId: "sc-61468579-8"
})(_templateObject15());
var PopoverIndicator = (0,styled_components_browser_esm/* default */.ZP)(Popover/* default */.ZP).attrs({
    overlayInnerStyle: {
        border: "1px solid ".concat(color/* default.gainsboro */.Z.gainsboro)
    }
}).withConfig({
    componentId: "sc-61468579-9"
})(_templateObject16());
var NotationBadgeContainer = (0,styled_components_browser_esm/* default */.ZP)(Tag/* default */.Z).withConfig({
    componentId: "sc-61468579-10"
})(_templateObject17());
var NotationPopoverContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-11"
})(_templateObject18());
var MultiplierContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-12"
})(_templateObject19());
var MultiplierChip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-13"
})(_templateObject20());
var TradingLimitBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-14"
})(_templateObject21());
var PopoverBadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-15"
})(_templateObject22());



/***/ })

}]);